export const makeLicense = (resp) => {
    const prices = resp.searchAccessPrices?.length > 0
        ? Object.assign({}, ... resp.searchAccessPrices.map((p) => ({[p.periodType]: ({
            base: p.base,
            personal: p.personal,
            discount: p.discount,
            periodType: p.periodType

        })})))
        : null;

    return {
        searchAccessFinishUtc: resp.searchAccessFinishUtc,
        searchAccessRemainingTime: resp.searchAccessRemainingTime,
        searchAccessPrices: prices,
        contactCityId: resp.contactCityId,
        contactCountryId: resp.contactCountryId,
    };
};

export const makeProfile = (profile) => {
    if (!profile?.contact) {
        return null;
    }

    return {
        balance: profile.contact.balance,
        forbidWriteOff: profile.contact.forbid_virtual_account_operations
    };
};

export const makeGeo = (resp) => {
    if ((!resp?.cities || resp.cities.length === 0) && (!resp?.countries || resp.countries.length === 0) && (!resp?.regions || resp.regions.length === 0))
        return null;

    const geoPoints = [];
    resp.cities?.forEach((city) => {
        geoPoints.push({
            id: city.cityId,
            name: city.name,
            type: 2,
            countryId: city.countryId
        });
    });

    resp.countries?.forEach((country) => {
        geoPoints.push({
            id: country.countryId,
            name: country.name,
            type: 0,
            countryId: country.countryId
        });

    });

    resp.regions?.forEach((region) => {
        geoPoints.push({
            id: region.regionId,
            name: region.clarifiedName,
            type: 1,
            countryId: region.countryId
        });
    });

    return geoPoints;
};

export const makeGeoRequest = (inputValue, locale) => {
    return {
        prefix: inputValue,
        geo_types: 7,
        language: locale === 'en' ? 1 : 0
    };
};

export const makeGeoSearchRequest = (geoList) => {
    let request = [];

    geoList.forEach((geo) => request.push({id: geo.id, type: geo.type}));

    return request;
};

export const makeMetricEventRequest = (action, targetFirms, from, to, resultsCount, searchId) => {
    const now = new Date();
    return {
        action,
        targetFirms,
        searchFrom: from,
        searchTo: to,
        searchResultCount: resultsCount,
        timezone_offset: now.getTimezoneOffset(),
        searchId
    };
};
